import { Typography } from '@mui/material'
import { FlexBoxProps, useAsyncEffect } from '@xylabs/sdk-react'
import { useState } from 'react'

import { useGeotoken } from '../../Contexts'
import { Property } from '../Property'

const LockedProperty: React.FC<FlexBoxProps> = (props) => {
  const geotoken = useGeotoken()

  const [locked, setLocked] = useState<boolean | null>()
  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (isMounted) => {
      const data = await geotoken?.getLocked()
      if (!isMounted()) return
      setLocked(data)
    },
    [geotoken],
  )

  return (
    <Property title="Locked" value={locked} {...props}>
      <Typography variant="caption">{locked === undefined ? '' : locked ? 'Yes' : 'No'}</Typography>
    </Property>
  )
}

export default LockedProperty
